import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";

//COMPONENTS
import MainMenu from "./mainMenu";
import SectionsBackgrounds from "../sectionsBackgrounds/admin/config";

function PodRouter() {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        setIsLoaded(true);
    }, []);

    return (
        <div>
            {isLoaded && (
                <div>
                    <Routes>
                        <Route path="/" element={<MainMenu />} />
                        <Route path="/secBackgrounds" element={<SectionsBackgrounds />} />
                    </Routes>
                </div>
            )}
        </div>
    );
}

export default PodRouter;
